module.exports = __webpack_public_path__ + "static/media/crosshair.b15ec825.svg";